import { IMPLEMENT_TYPES, ImplementType } from "../constants/implementTypes";

export function getImplementByType(type: ImplementType) {
  const implement = IMPLEMENT_TYPES.find((implement) => implement.type === type);

  if (!implement) {
    // toast.error("Tipo de implemento inválido ou não encontrado.");

    return {
      type: "UNKNOWN" as ImplementType,
      shaftQuantity: 0,
      grossCapacity: 0,
      netCapacity: 0
    };
  }

  return implement;
}
